import { rollbar } from '@/modules/shared/infra/rollbar.config'
import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type AuthPasswordServiceInput = {
  payload: {
    email?: string
    password?: string
    company?: string
  }
}

export const authPasswordService = async ({
  payload,
}: AuthPasswordServiceInput): Promise<ResponseAPI> => {
  rollbar.configure({
    enabled: false,
  })
  const response = await api.post<ResponseAPI>('login', {
    usuario: payload.email,
    senha: payload.password,
    empresa: payload.company,
  })

  rollbar.configure({
    enabled: true,
  })

  return response.data
}
